export class SnapshotProvider {
  public static capture<T>(source: T, deep = false): T {
    const snapshot: any = {};
    for (const property in source) {
      if (source[property] instanceof Object && !(source[property] instanceof Date)) {
        if (deep) {
          snapshot[property] = SnapshotProvider.capture(source[property], deep);
        }
      } else {
        snapshot[property] = source[property];
      }
    }
    return snapshot as T;
  }

  public static diff<T>(original: T, updated: T, keys: Array<string> = null, excludedKeys: Array<string> = ['_links']) {
    const diffObj: any = {};
    keys ??= Object.keys(original);
    keys = keys.filter(k => !excludedKeys.includes(k));

    for (const key of keys) {
      const updatedValue = updated[key];
      const originalValue = original[key];
      if (originalValue == updatedValue) {
        continue;
      }
      diffObj[key] = updatedValue;
    }
    return diffObj;
  }
}
